'use client';
import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import MWSVG from '../common/svg';
import Link from 'next/link';
import Image from 'next/image';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useRouter } from 'next/navigation';
import { postRequest } from '@/api/helpers';
import { routes } from '@/api/routes';
import { isEmpty } from '@/utils/common-helpers';

type Props = {
    position: string;
    exp?: any;
    location: any;
};
const customStyles = {
    overlay: {
        zIndex: 9999,
        backgroundColor: 'rgba(0,0,0,0.6)',
        padding: 0,
    },
    content: {
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#fff',
        border: '0',
        maxWidth: '1370px',
        width: '95%',
        padding: '0',
    },
};

const OpeningCard: React.FC<Props> = ({ position, exp, location }) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);


    const closeModal = () => {
        setIsOpen(false);
    };
    const { push } = useRouter();

    const { executeRecaptcha } = useGoogleReCaptcha();

    const [submitButtonDisable, setSubmitButtonDisable] = useState<boolean>(false);

    const isValidInquiry = () => {
        return false;
    };

    const handleSubmitForm = useCallback(
        (e: any) => {
            e.preventDefault();
            if (isValidInquiry()) {
                setSubmitButtonDisable(true);

                if (!executeRecaptcha) {
                    setSubmitButtonDisable(false);
                    toast('Execute recaptcha not yet available!', {
                        autoClose: 2000,
                        type: 'error',
                        position: 'bottom-right',
                    });
                    return;
                }
                executeRecaptcha('enquiryFormSubmit').then(async (gReCaptchaToken: any) => {
                    await submitInquiry(gReCaptchaToken);
                });
            }
        },
        [executeRecaptcha],
    );

    const submitInquiry = async (gReCaptchaToken: string) => {
        const inquiryFromData = new FormData();

        const res = await postRequest(routes.CONTACT_INQUIRY_SUBMIT, inquiryFromData, {
            'Content-Type': 'multipart/form-data',
            recaptcha: gReCaptchaToken,
        });

        if (res.status !== 201 || !res.data.status) {
            toast('Something went wrong! Please try again sometime!', {
                autoClose: 2000,
                type: 'error',
                position: 'bottom-right',
            });
        } else {
            clearRef();
            push('/thank-you');
        }
        setSubmitButtonDisable(false);
    };

    const clearRef = () => {
        return;
    };

    return (
        <div className="justify-between items-center mb-5 bg-white card sm:flex md:flex">
            <div>
                <div className="px-5 py-5 md:px-5 lg:px-30">
                    <h3 className="mb-1 card-title fs-lg fw-700">{position}</h3>
                    {!isEmpty(exp) && <p className="mb-1 card-text fs-md fw-600">Experience: {exp}</p>}
                    <p className="mb-0 card-text fs-md fw-600">Location: {location}</p>
                </div>
            </div>
            <div>
                <div className="px-5 py-5 md:px-5 lg:px-30">
                    <button
                        className="btn btn-outline-primary min-w-[150px]"
                        aria-label="Apply for"
                        // onClick={() => {
                        //   openModal()
                        // }}
                        onClick={() => {
                            window.open(`mailto:hr@moweb.com?subject=Applied for ${position} position`);
                        }}
                    >
                        Apply Now
                    </button>
                    <div>
                        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
                            <div
                                onClick={closeModal}
                                className="absolute right-5 pt-5 text-right cursor-pointer text-secondary btn-close"
                            >
                                <MWSVG id="ic_close" svgClassName="text-secondary" />
                            </div>
                            <div className="grid md:grid-cols-12 lg:grid-cols-12 apply-box">
                                <div className="md:col-span-7 lg:col-span-7">
                                    <div className="px-9 py-10">
                                        <h2 className="mb-0 text-blue">Let&apos;s Transform Your Vision Into Value. </h2>
                                        <hr className="my-5 opacity-10 bg-secondary" />
                                        <form
                                            className="grid gap-x-5 gap-y-5 md:grid-cols-2 md:gap-x-7 text-secondary"
                                            autoComplete="off"
                                        >
                                            {/* 
                    <div>
                      */}
                                            <div className="md:col-span-2">
                                                <label className="block">
                                                    <span>Position Applied For</span>
                                                    <span className="text-red-600">*</span>
                                                    <select className="form-select">
                                                        <option selected>Android Developer</option>
                                                        <option value="1">Fronted Developer</option>
                                                        <option value="2">UI/UX Developer</option>
                                                        <option value="3">Php Developer</option>
                                                    </select>
                                                </label>
                                            </div>
                                            <label className="block">
                                                <span>First Name</span>
                                                <span className="text-red-600">*</span>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Type here..."
                                                />
                                            </label>
                                            <label className="block">
                                                <span>Last Name</span>
                                                <span className="text-red-600">*</span>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Type here..."
                                                />
                                            </label>
                                            <div>
                                                <label className="block">
                                                    <span>Phone Number</span>
                                                    <span className="text-red-600">*</span>
                                                    <input
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control"
                                                        placeholder="Type here..."
                                                    />
                                                </label>
                                            </div>
                                            <label className="block">
                                                <span>Email</span>
                                                <span className="text-red-600">*</span>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Type here..."
                                                />
                                            </label>
                                            <label className="block">
                                                <span>Total Experience</span>
                                                <span className="text-red-600">*</span>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Type here..."
                                                />
                                            </label>
                                            <label className="block">
                                                <span>Relevant Experience</span>
                                                <span className="text-red-600">*</span>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Type here..."
                                                />
                                            </label>

                                            <label className="block">
                                                <span>Notice Period</span>
                                                <span className="text-red-600">*</span>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Type here..."
                                                />
                                            </label>
                                            <label className="block">
                                                <span>LinkedIn Profile</span>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Type here..."
                                                />
                                            </label>
                                            <div className="md:col-span-2">
                                                <label className="block">
                                                    <span>Current Company</span>
                                                    <input
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control"
                                                        placeholder="Type here..."
                                                    />
                                                </label>
                                            </div>
                                            <div className="md:col-span-2">
                                                <label className="block"></label>
                                                <span>Upload Resume</span>
                                                <span className="text-red-600">*</span>
                                                <div className="mt-1 h-24 upldimg">
                                                    <label htmlFor="file-upload" className="mb-0 custom-file-upload">
                                                        Click to select or drop files here (max 5mb)*
                                                    </label>
                                                    <input id="file-upload" type="file" />
                                                </div>
                                            </div>
                                            <div className="md:col-span-2">
                                                <label className="block">
                                                    <span>Message</span>
                                                    <span className="text-red-600">*</span>
                                                    <textarea className="form-control" rows={3} placeholder="Type here..." />
                                                </label>
                                            </div>
                                            <div className="md:col-span-2">
                                                <div className="flex flex-wrap items-center">
                                                    <button
                                                        type="button"
                                                        aria-label="Submit"
                                                        className="mr-4 mb-2 cursor-pointer btn btn-primary md:mb-0"
                                                        disabled={submitButtonDisable}
                                                        onClick={handleSubmitForm}
                                                    >
                                                        Submit
                                                    </button>
                                                    <p className="mb-0 fs-sm fw-500 text-secondary">
                                                        Please fill all the required fields.
                                                    </p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="md:col-span-5 lg:col-span-5">
                                    <div className="address-box">
                                        <div className="grid gap-30 address-box-spacing">
                                            <div className="flex flex-col gap-2.5 mb-5 md:mb-0 md:col-span-1">
                                                <p className="footer-title mb-2.5 text-textcolor dark:text-light">
                                                    <svg className="me-2.5" width={'40'} height={'23'}>
                                                        <use xlinkHref="#flag-india" />
                                                    </svg>
                                                    India
                                                </p>
                                                <p className="mb-0 font-medium fs-md">
                                                    Sarthak House, Swastik Cross Road,
                                                    <br /> C. G. Road, Ahmedabad - 380027
                                                </p>
                                                <p className="mb-0 font-medium fs-md">
                                                    <Link href="tel:+91 840 999 9995">+91 840 999 9995</Link>
                                                </p>
                                            </div>
                                            <div className="flex flex-col gap-2.5  mb-5 md:mb-0 md:col-span-1">
                                                <p className="footer-title mb-2.5 text-textcolor dark:text-light">
                                                    <svg className="me-2.5" width={'40'} height={'23'}>
                                                        <use xlinkHref="#flag-uk" />
                                                    </svg>
                                                    UK
                                                </p>
                                                <p className="mb-0 font-medium fs-md">
                                                    245 Kenton Lane, Harrow, Middlesex,
                                                    <br /> London HA3 8RP
                                                </p>
                                                <p className="mb-0 font-medium fs-md">
                                                    <Link href="tel:+44 (203) 286 5989">+44 (203) 286 5989</Link>
                                                </p>
                                            </div>
                                            <div className="flex flex-col gap-2.5 md:col-span-1">
                                                <p className="footer-title mb-2.5 text-textcolor dark:text-light">
                                                    <svg className="me-2.5" width={'40'} height={'23'}>
                                                        <use xlinkHref="#flag-usa" />
                                                    </svg>
                                                    USA
                                                </p>
                                                <p className="mb-0 font-medium fs-md">
                                                    11 Blanche St, Secaucus, New Jersey (NJ) 07094
                                                </p>
                                                <p className="mb-0 font-medium fs-md">
                                                    <Link href="tel: +1 (862) 223-8944">+1 (862) 223-8944</Link>
                                                </p>
                                            </div>
                                            <div className="flex flex-col md:col-span-1">
                                                <hr className="m-0 opacity-10 bg-secondary" />
                                            </div>
                                            <div className="flex flex-col m-0 md:col-span-1">
                                                <p className="font-medium fs-md">
                                                    <span
                                                        className="cursor-pointer link-footer"
                                                        onClick={() => {
                                                            window.open('mailto:hr@moweb.com');
                                                        }}
                                                    >
                                                        <MWSVG id="ic-email" svgClassName="me-2" />
                                                        hr@moweb.com
                                                    </span>
                                                </p>
                                                <p
                                                    className="cursor-pointer link-footer fs-md"
                                                    onClick={() => {
                                                        window.open('skype:isoftsolutionsin?call');
                                                    }}
                                                >
                                                    <span>
                                                        <MWSVG id="ic-skype" svgClassName="me-2" />
                                                        isoftsolutionsin
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="jobapplyimgres">
                                            <Image
                                                src="/img/career/img-applyjob@2x.webp"
                                                alt="job apply"
                                                title="job apply"
                                                height="351"
                                                width="568"
                                                loading="lazy"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpeningCard;
